import React from 'react';

import ThemeTeaser from './Teaser';
import ThemeFull from './Full';
import ThemeCard from './Card';

import type { ImmutableTaxonomyTheme } from '../../../types/taxonomy';

export interface ThemeProps {
  entity: ImmutableTaxonomyTheme,
  classNames: string,
  viewMode: 'default' | 'full' | 'teaser' | 'card';
  menuTeaser: boolean,
  isDesktop: boolean,
  onClick: () => {},
}

const Theme: React.FC<ThemeProps> = (props) => {
  const { viewMode } = props;
  if (viewMode === 'card') {
    return <ThemeCard {...props} />;
  }

  if (viewMode === 'teaser') {
    return <ThemeTeaser {...props} />;
  }

  return <ThemeFull {...props} />;
};

export default Theme;
